<div class="document-badge"
     [ngStyle]="containerStyle"
     (click)="onClick($event)">
    <div *ngIf="badgeText"
         class="document-badge-content"
         [ngStyle]="contentStyle">
        {{ badgeText }}
    </div>
</div>
